import { markdownContentStyles } from 'app/pages/loanApplication/components/GuidelineCitations/CitedContent/CitedContent.styles';

import { COLOR_PALETTE } from 'constants/ui';

import { MESSAGE_TOOLS_CLASS_NAME } from '../MessageTools/MessageTools.constants';

import { FEEDBACK_BUTTONS_CLASS_NAME } from './components/FeedbackButtons/FeedbackButtons.constants';

export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '100%',
};

export const contentWrapperStyles = {
  flex: 1,
  minWidth: 0,
  gap: '4px',
  [`&:hover .${MESSAGE_TOOLS_CLASS_NAME}`]: {
    opacity: 1,
    pointerEvents: 'auto',
  },
  [`&:hover .${FEEDBACK_BUTTONS_CLASS_NAME}`]: {
    opacity: 1,
    pointerEvents: 'auto',
  },
};

export const messageContentListStyles = {
  minWidth: 0,
  gap: '8px',
  borderRadius: '12px',
  wordBreak: 'break-word',
  borderTopLeftRadius: '4px',
  ...markdownContentStyles,
};

export const messageToolsHiddenStyles = {
  opacity: 0,
  pointerEvents: 'none',
  transition: 'opacity 0.2s ease-in-out',
};

export const streamingCaretStyles = {
  display: 'inline-block',
  width: '8px',
  height: '14px',
  marginLeft: '4px',
  verticalAlign: 'text-bottom',
  backgroundColor: COLOR_PALETTE.BLUE[7],
  borderRadius: '1px',
  animation: 'aiChatStreamingCaretBlink 1s steps(2, start) infinite',
  '@keyframes aiChatStreamingCaretBlink': {
    to: { visibility: 'hidden' },
  },
};
